import React, { Fragment, useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Select from 'react-select';
import EditIcon from '@mui/icons-material/Edit';
import DatePicker from 'react-datepicker';
import axios from 'axios';
import CancelIcon from '@mui/icons-material/Cancel';
import SaveIcon from '@mui/icons-material/Save';
import SendIcon from '@mui/icons-material/Send';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Modal from '@mui/material/Modal';


function ExpenseEditPage() {
    const history = useHistory();
    const { id } = useParams(); // Assuming you're passing the expense ID through the URL
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [note, setNote] = useState('');
    const [amount, setAmount] = useState('');
    const [selectedExpenseType, setSelectedExpenseType] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [itemList, setItemList] = useState([]);
    const [newItem, setNewItem] = useState({});
    const [selectedOption, setSelectedOption] = useState('');

    const [selectedDate, setSelectedDate] = useState(new Date());
    const [formData, setFormData] = useState({
        ExpenseID: '',
        CompanyID: '',
        EngineerID: '',
        ModifiedBy: userId,

    });

    const [itemdata, setData] = useState([]);

    useEffect(() => {
        fetchData('ExpenseApi', `/ ExpenseDetails/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                    setFormData(response.response_data);
                    console.log(response);

                }

                setFormData((prevData) => ({
                    ...prevData,
                    ModifiedBy: userId,
                }));

            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);


    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     setIsLoading(true);

    //     const updatedData = {
    //         Note: note,
    //         Amount: amount,
    //         ExpenseType: selectedExpenseType,
    //         ExpenseEntryDate: selectedDate,

    //     };

    //     try {
    //         const response = await updateData(`ApprovedClaimsAPI/${id}`, updatedData);
    //         if (response.responseCode === '1111') {
    //             console.log('Expense updated successfully:', response.responseMessage);
    //             history.push('/Home');
    //         } else {
    //             console.error('Error updating expense:', response.responseMessage);
    //         }
    //     } catch (error) {
    //         console.error('Error updating expense:', error);
    //     }

    //     setIsLoading(false);
    // };


    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };


    const [ExpenseTypeOptions, setExpenseTypeOptions] = useState([]);

    const fetchExpenseTypes = async () => {
        try {
            const response = await fetchData('ExpenseTypeApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(customer => ({
                    value: customer.name,
                    label: customer.name
                }));
                setExpenseTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Expense Types:', error);
        }
    };

    const handleExpenseTypeChange = (selectedOption) => {
        setSelectedExpenseType(selectedOption);
    };

    useEffect(() => {
        fetchExpenseTypes();
    }, []);


    // const AddtoListdata = (e) => {
    //     e.preventDefault();

    //     const updatedItem = { ...newItem };

    //     updatedItem.Note = note;
    //     updatedItem.Amount = amount;
    //     updatedItem.selectedExpenseType = selectedExpenseType.label;

    //     setItemList([...itemList, updatedItem]);

    //     setNewItem({
    //         ExpenseType: '',
    //         Note: '',
    //         Amount: 0,
    //         ...(selectedOption === 'spare' && { ExpenseType: selectedExpenseType })
    //     });
    //     setSelectedExpenseType('');
    //     setNote('');
    //     setAmount('');
    // };

    const AddtoListdata = (e) => {
        e.preventDefault();

        const updatedItem = { ...newItem };
        updatedItem.note = note;
        updatedItem.amount = amount;
        updatedItem.expenseName = selectedExpenseType.label;
        setData([...itemdata, updatedItem]);

        setNewItem({
            ExpenseType: '',
            Note: '',
            Amount: 0,
            ...(selectedOption === 'spare' && { ExpenseType: selectedExpenseType })
        });
        setSelectedExpenseType('');
        setNote('');
        setAmount('');
    };



    const handleDelete = (index) => {
        const updatedList = [...itemList];
        updatedList.splice(index, 1);
        setItemList(updatedList);
    };

    const removeRecord = (index) => {
        const isConfirmed = window.confirm("Are you sure you want to remove the record?");
        if (isConfirmed) {
            const updatedRecords = [...itemdata];
            updatedRecords.splice(index, 1);
            setData(updatedRecords);
        }

    };

    // Define state variables for editing
    const [editIndex, setEditIndex] = useState(null);
    const [editExpenseName, setEditExpenseName] = useState('');
    const [editNote, setEditNote] = useState('');
    const [editAmount, setEditAmount] = useState('');

    // Function to handle edit icon click
    const handleEditClick = (index, expenseName, note, amount) => {
        setEditIndex(index);
        setEditExpenseName(expenseName);
        setEditNote(note);
        setEditAmount(amount);
    };

    // // Function to handle save after editing
    // const handleSaveEdit = () => {
    //     // Update the item in itemdata array
    //     const updatedItemdata = [...itemdata];
    //     updatedItemdata[editIndex] = {
    //         expenseName: editExpenseName,
    //         note: editNote,
    //         amount: editAmount
    //     };
    //     setData(updatedItemdata);

    //     // Clear editing state
    //     setEditIndex(null);
    //     setEditExpenseName('');
    //     setEditNote('');
    //     setEditAmount('');
    // };

    // const handleSubmit = async (event) => {
    //     event.preventDefault();

    //     const ExpenseItems = itemdata.map(item => {

    //         return {
    //             ID: formData.expenseItemID,
    //             ExpenseID: id,
    //             ExpenseType: item.expenseName,
    //             CompanyID: companyId,
    //             Amount: item.amount,
    //             Note: item.note,
    //             ModifiedBy: userId,

    //         };
    //     });

    //     const Expenses = {
    //         ID: id,
    //         EngineerID: formData.engineerID,
    //         CompanyID: companyId,
    //         ModifiedBy: userId,

    //     };

    //     const type = {
    //         expense: Expenses,
    //         expenseItem: ExpenseItems
    //     };

    //     try {
    //         const response = await updateData('ApprovedClaimsAPI', `${id}`, type, token);
    //         console.log('Record updated successfully:', response.data);
    //         history.push('/Index');
    //     } catch (error) {
    //         console.error('Error updating record:', error);
    //     }

    //     setIsLoading(false);
    // };

    // Function to handle save after editing

    const handleSaveEdit = () => {
        // Update the item in itemdata array
        const updatedItemdata = [...itemdata];
        updatedItemdata[editIndex] = {
            expenseID: itemdata[editIndex].expenseID,
            companyID: itemdata[editIndex].companyID,
            expenseItemID: itemdata[editIndex].expenseItemID,
            engineerID: itemdata[editIndex].engineerID,
            expenseName: editExpenseName,
            note: editNote,
            amount: editAmount
        };
        setData(updatedItemdata);

        // Clear editing state
        setEditIndex(null);
        setEditExpenseName('');
        setEditNote('');
        setEditAmount('');
    };


    const handleSubmit = async (event) => {
        event.preventDefault();

        const ExpenseItems = itemdata.map(item => {
            return {
                ID: item.expenseItemID,
                ExpenseID: item.expenseID,
                ExpenseType: item.expenseName,
                CompanyID: item.companyID,
                Amount: item.amount,
                Note: item.note,
                ModifiedBy: userId,
            };
        });

        const Expenses = {
            ID: itemdata[0].expenseID,
            EngineerID: itemdata[0].engineerID,
            CompanyID: companyId,
            ModifiedBy: userId,
        };

        const type = {
            expense: Expenses,
            expenseItem: ExpenseItems
        };

        try {
            const response = await updateData('ApprovedClaimsAPI', `${id}`, type, token);
            console.log('Record updated successfully:', response.data);
            history.push('/Index');
        } catch (error) {
            console.error('Error updating record:', error);
        }

        setIsLoading(false);
    };


    return (


        <div className="w-full max-w-sm container mt-6 mx-auto">

            <div className='w-full mb-2 flex'>
                <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>DAILY EXPENSE EDIT</h6>

                <div className="button-container-2">

                    <Tooltip title="Exit">
                        <Link to="/Index" style={{ marginTop: '-30px', color: 'red', textDecoration: 'none' }}>
                            <Button style={{ color: 'red' , fontWeight:'bolder' }}>
                                Back TO LIST<ArrowForwardIosIcon />
                            </Button>
                        </Link>
                    </Tooltip>

                    <Tooltip title="Submit">
                        <Button onClick={handleSubmit} style={{ color: 'green', fontWeight:'bolder'  }} disabled={isLoading}>
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : "Save"} <CheckCircleIcon />
                        </Button>
                    </Tooltip>
                </div>
            </div >
            {/* {!isModalOpen && (
                <Button onClick={openModal} style={{ marginTop: '-20px', color: 'white', backgroundColor: 'black', fontWeight: 'bolder', height: '20px' }}>+ Add</Button>

            )} */}

            <Modal open={isModalOpen} className={isModalOpen ? 'notification-modal' : ''}>
                <div className="notification-modal" style={{ backgroundColor: 'white', maxHeight: '400px' }}>
                    <br></br>
                    <h4 style={{ textAlign: 'center', fontFamily: 'Times New Roman', fontWeight: 'bolder', color: 'ThreeDHighlight' }}>Add Expense</h4>
                    <div className="bg-tabcolor-100 rounded-lg shadow-lg p-6">


                        <div className="w-full mb-4 flex">
                            <div className="w-1/7 mr-3" style={{ marginTop: '-20px' }}>
                                <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="packingDate" style={{ fontSize: '16px' }}>
                                    Date
                                </label>
                                <DatePicker
                                    selected={selectedDate}
                                    onChange={date => setSelectedDate(date)}
                                    dateFormat="dd/MM/yyyy"
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                />
                            </div>
                            <div className="w-1/7 mr-3" style={{ width: '275px', marginTop: '-20px' }}>
                                <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="packingDate" style={{ fontSize: '16px' }}>
                                    Expense
                                </label>
                                <Select
                                    value={selectedExpenseType}
                                    onChange={handleExpenseTypeChange}
                                    options={ExpenseTypeOptions}
                                    placeholder="--Expense--"
                                    isSearchable
                                />
                            </div>
                        </div>
                        <div className="w-full mb-4 flex">
                            <div className="w-1/7 mr-3" style={{ width: '400px', marginTop: '-22px' }}>
                                <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="packingSlipNumber" style={{ fontSize: '16px' }}>
                                    Note
                                </label>
                                <textarea
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={note}
                                    onChange={(e) => setNote(e.target.value)}
                                    placeholder="Enter Notes"
                                    rows={3}
                                    maxLength={250}
                                />
                            </div>
                        </div>
                        <div className="w-full mb-4 flex">
                            <div className="w-full md:w-1/2 pr-2" style={{ marginTop: '-20px', width: '150px' }}>
                                <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="AddressLine1">
                                    Amount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={amount}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d*\.?\d*$/.test(value)) {
                                            setAmount(value);
                                        }
                                    }}
                                    pattern="^\d*\.?\d*$"
                                    maxLength={5}
                                />
                            </div>
                        </div>
                        <br></br>
                        <div className="w-full mb-4 flex">

                            <Tooltip title="Add">
                                <Button onClick={AddtoListdata} style={{ marginTop: '-30px', color: 'green', cursor: 'pointer' }}>
                                    ADD <CheckCircleIcon />
                                </Button>
                            </Tooltip>

                            <Tooltip title="Cancel">
                                <Button onClick={closeModal} style={{ marginTop: '-30px', color: 'red', border: 'none', background: 'none', cursor: 'pointer' }}>
                                    Cancel<CancelIcon />
                                </Button>
                            </Tooltip>
                        </div>
                    </div>
                </div>
            </Modal>


            <div className="overflow-auto" style={{ overflowY: 'auto' }}>
                <table className="w-full border-collapse border" style={{ overflowY: 'auto' }}>
                    <thead>
                        <tr className="bg-gray-200 border-b">
                            <th className="px-4 py-2 text-left border-r" style={{ width: '5px' }}>Sl.no</th>
                            <th className="px-4 py-2 text-left border-r" style={{ width: '500px' }}>Expense</th>
                            <th className="px-4 py-2 text-left border-r" style={{ width: '500px' }}>Note</th>
                            <th className="px-4 py-2 text-left border-r" style={{ width: '150px' }}>Amount</th>
                            <th style={{ padding: '8px' }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {itemdata.map((item, index) => (
                            <tr key={index} className={index % 2 === 0 ? 'bg-gray-100' : 'bg-white'}>
                                {editIndex === index ? (
                                    <>
                                        <td className="px-4 py-2 border-r" style={{ width: '5px', padding: '5px' }}>{index + 1}</td>
                                        {/* <td className="px-4 py-2 border-r" style={{ width: '500px' }}>
                                            <input value={editExpenseName} onChange={(e) => setEditExpenseName(e.target.value)} readOnly/>
                                        </td> */}
                                        <td className="px-4 py-2 border-r" style={{ width: '500px', padding: '5px' }}>{item.expenseName}</td>
                                        <td className="px-4 py-2 border-r" style={{ width: '500px', padding: '5px' }}>
                                            <textarea value={editNote} onChange={(e) => setEditNote(e.target.value)} />
                                        </td>
                                        <td className="px-4 py-2 border-r" style={{ width: '150px', textAlign: 'right', cursor: 'pointer' }}>
                                            <input value={editAmount} onChange={(e) => setEditAmount(e.target.value)} />
                                        </td>
                                        <td style={{ padding: '8px', marginTop: '-15px' }}>
                                            <Tooltip title="Save">
                                                <IconButton style={{ padding: '8px', marginTop: '-10px', color: 'green' }} onClick={handleSaveEdit}>
                                                    <SaveIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </td>
                                    </>

                                ) : (
                                    
                                    <>
                                        <td className="px-4 py-2 border-r" style={{ width: '5px' }}>{index + 1} <Tooltip title="Edit">
                                            <IconButton style={{ padding: '8px', marginTop: '-10px', color: 'blue' }} onClick={() => handleEditClick(index, item.expenseName, item.note, item.amount)}>
                                                <EditIcon />
                                            </IconButton>
                                        </Tooltip></td>
                                        <td className="px-4 py-2 border-r" style={{ width: '500px', padding: '5px' }}>{item.expenseName}</td>
                                        <td className="px-4 py-2 border-r" style={{ width: '500px', padding: '5px' }}>{item.note}</td>
                                        <td className="px-4 py-2 border-r" style={{ width: '150px', textAlign: 'right', cursor: 'pointer' }}>{item.amount}</td>
                                        <td style={{ padding: '8px', marginTop: '-15px' }}>

                                            <Tooltip title="Delete">
                                                <IconButton style={{ padding: '8px', marginTop: '-10px', color: '#FFD700' }} onClick={() => removeRecord(index)}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </td>
                                    </>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

        </div>

    );
}


export default ExpenseEditPage;
